import { render, staticRenderFns } from "./Houses.vue?vue&type=template&id=e4e89d7e&"
import script from "./Houses.vue?vue&type=script&lang=js&"
export * from "./Houses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Houses.vue"
export default component.exports